<template src="./template.html"></template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { directive as onClickaway } from 'vue-clickaway';
import date from '@/mixins/date';
import Popup from "@/components/global/popup/index.vue";

export default {
  name: 'NotificationsMenu',
  components: { Popup },
  mixins: [date],
  directives: {
    onClickaway: onClickaway,
  },
  data() {
    return {
      activeMenuItem: '',
      isOpen: false,
      activeCategory: 'alerts',
      openPopup: false,
      showNews: null,
      loadingMore: false, // New loading flag
      currentNotificationPage: 1,     // Page tracking for pagination
      currentNewsPage: 1,     // Page tracking for pagination
      _pollTimer: null,
    };
  },
  beforeDestroy() {
    if (this._pollTimer) clearTimeout(this._pollTimer);
  },
  computed: {
    ...mapGetters([
      'get_news',
      'get_news_pages',
      'get_unread_news_count',
      'get_notification_list',
      'get_notification_list_pages',
      'get_unread_notification_count',
    ]),
    newsCount() {
      return this.get_unread_news_count || 0;
    },
    alertCount() {
      return this.get_unread_notification_count || 0;
    },
    totalCount() {
      return this.newsCount + this.alertCount;
    },
    hasNews() {
      return this.get_news.length > 0
    },
    hasNotifications() {
      return this.get_notification_list.length > 0
    }
  },
  mounted() {
    this.getNotifications();
  },
  methods: {
    async getNotifications() {
      if (!this.$store.getters.get_is_authed) return;
      if (this.currentNotificationPage <= 1 || this.activeCategory === 'news') {
        await this.$store.dispatch('GET_INTERNAL_NOTIFICATIONS').then(() => {
          this.currentNotificationPage = 1;
        });
      }
      if (this.currentNewsPage <= 1 || this.activeCategory === 'alerts') {
        await this.$store.dispatch('GET_NEWS').then(() => {
          this.currentNewsPage = 1;
        });
      }

      this._pollTimer = setTimeout(() => this.getNotifications(), 60000);
    },
    loadNotificationCategory(category) {
      this.activeCategory = category;
      this.currentNotificationPage = 1;
      this.currentNewsPage = 1;
    },
    closeMenu() {
      this.isOpen = false;
      this.currentNotificationPage = 1;
      this.currentNewsPage = 1;
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.showNews = null;
    },
    openNewsPopup(item) {
      this.$store.dispatch('MARK_NEWS_SEEN', item);
      this.showNews = item;
      this.openPopup = true;
    },
    openEntity(item) {
      if (item.type_id === 1) {
        this.$router.push(`/view-shipment/${item.entity_id}`)
        this.closeMenu()
      }
    },
    async loadMoreNotifications() {
      if (this.loadingMore) return; // Prevent multiple calls
      const category = this.activeCategory;
      this.loadingMore = true;

      // Fetch the next page of data
      const action = category === 'alerts' ? 'GET_INTERNAL_NOTIFICATIONS' : 'GET_NEWS';
      const pages = (category === 'alerts' ? this.get_notification_list_pages : this.get_news_pages);
      const page =  category === 'alerts' ? ++this.currentNotificationPage : ++this.currentNewsPage;

      if (pages >= page) {
        await this.$store.dispatch(action, { page: page }).catch(() => {
          // Handle any errors here
          category === 'alerts' ? this.currentNotificationPage-- : this.currentNewsPage--;
        });
      }
      this.loadingMore = false;
    },
    handleScroll() {
      const list = this.$refs.notificationList;
      if (list.scrollHeight - list.scrollTop <= list.clientHeight + 50) {
        this.loadMoreNotifications();
      }
    },
  },
  watch: {
    isOpen(val) {
      if (val && this.activeCategory === 'alerts') {
        this.$store.dispatch('MARK_INTERNAL_NOTIFICATIONS_SEEN');
      }
    },
    activeCategory(val) {
      if (val === 'alerts') {
        this.$store.dispatch('MARK_INTERNAL_NOTIFICATIONS_SEEN');
      }
    },
  },
};

</script>
<style lang="scss">
.notification-list {
  max-height: 400px;
  overflow-y: auto;

  /* width */
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
</style>

